"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_usestateref_1 = __importDefault(require("react-usestateref"));
const usehooks_ts_1 = require("usehooks-ts");
const useAsyncHandler_1 = __importDefault(require("./useAsyncHandler"));
function useAsyncFetch(onActionFn, options, dependencies) {
    if (options instanceof Array) {
        dependencies = options;
        options = {};
    }
    const { maxTries = 1, timeoutBeforeRetry = 1000 } = options || {};
    const [tries, setTries, triesRef] = (0, react_usestateref_1.default)(0);
    const [isTimeoutEnabled, setTimeoutEnabled] = (0, react_usestateref_1.default)(false);
    const action = (0, useAsyncHandler_1.default)(onActionFn, { strict: true });
    const { isLoading, isDone, isErrored, error, data, indicators } = action;
    const handleTry = (0, react_1.useCallback)(function handleTryFn() {
        const { isLoading, isDone } = indicators.stateRef.current;
        const tries = triesRef.current || 0;
        if (isDone || isLoading)
            return;
        setTries(tries + 1);
        action.execute()
            .catch(e => {
            let actionPrefix = onActionFn.name ? `(${onActionFn.name}) ` : '';
            console.error(`${actionPrefix}AsyncFetch action got error:`);
            console.error(e);
        });
    }, [action]);
    function reset() {
        action.reset();
        setTries(0);
    }
    (0, react_1.useEffect)(() => {
        reset();
        handleTry();
    }, dependencies || []);
    const isFetchNecessary = !isLoading && !isDone;
    (0, react_1.useEffect)(() => {
        if (isTimeoutEnabled)
            return;
        if (!isFetchNecessary)
            return;
        if (!tries || tries >= maxTries)
            return;
        setTimeoutEnabled(true);
    }, [isFetchNecessary, tries]);
    function handleTimeout() {
        setTimeoutEnabled(false);
        handleTry();
    }
    (0, usehooks_ts_1.useTimeout)(handleTimeout, isTimeoutEnabled ? timeoutBeforeRetry : null);
    return { isLoading, isDone, isErrored, error, data, reset, tries, indicators };
}
exports.default = useAsyncFetch;
